export default "__VITE_ASSET__CgFeDYWP__"